export { SocoAlertModule } from '@app/soco/alert/alert_module';

// DSS Documentation on SocoAlertComponent - http://tiny.sc/cgsocoalertcomponent
export { SocoAlertComponent } from '@app/soco/alert/soco-alert.component';
// DSS Documentation on SocoAlertService - http://tiny.sc/cgsocoalertservice
export { SocoAlertService, SocoAlertServiceOptions, SocoAlertLocation, SocoAlertType } from '@app/soco/alert/soco-alert.service';
